import { useState } from "react";
import {
  managementModalStyle,
  StyledModal,
} from "pages/PatientOverview/styles";
import { Box, Grid } from "@mui/material";
import { CircularProgress } from "@material-ui/core";
import { icons } from "constants/icons";
import { Button } from "components/Buttons/Button";
import { ButtonColorScheme, ButtonType } from "types/ui";
import { useAppDispatch } from "hooks/reduxHooks";
import { Checkbox } from "components/Checkbox/Checkbox";
import { DatePicker } from "components/DatePicker/DatePicker";
import { USER_GROUPS } from "constants/roles";
import { capitializeAndRemoveUnderScore } from "utils/general";
type Props = {
  isEnabled: boolean;
  loading: boolean;
  setIsEnabled: any;
  getList: any;
  roleFilters?: boolean;
};

const ROLE_FILTERS_INITIAL_STATE = {
  [USER_GROUPS.CLINICIAN]: false,
  [USER_GROUPS.CLINIC_ADMIN]: false,
  [USER_GROUPS.CLINIC_ASSISTANT]: false,
  [USER_GROUPS.CLINIC_TEAM_LEAD]: false,
  [USER_GROUPS.CLINIC_TEAM_MEMBER]: false,
};
const FILTERS_INITIAL_STATE = { status: "", date: new Date(), hasDate: false };

export const AuthStatusModal = ({
  isEnabled,
  setIsEnabled,
  loading,
  getList,
  roleFilters,
}: Props) => {
  const dispatch = useAppDispatch();
  const [filters, setFilters] = useState(FILTERS_INITIAL_STATE);
  const [roleFiltersState, setRoleFiltersState] = useState(
    ROLE_FILTERS_INITIAL_STATE,
  );

  const handleRolesFilter = (role: string) => {
    setRoleFiltersState({
      ...roleFiltersState,
      [role]: !roleFiltersState[role],
    });
  };
  const handleConfirm = () => {
    dispatch(getList(() => {}, getFilters()));
    setIsEnabled(false);
  };

  const getFilters = () => {
    let currentFilters = {};

    if (filters.status) {
      currentFilters = {
        ...currentFilters,
        authStatus: filters.status,
      };
    }
    if (filters.hasDate) {
      currentFilters = {
        ...currentFilters,
        inviteDate: filters.date.toISOString().slice(0, 10),
      };
    }

    const rolesArray = Object.keys(roleFiltersState).filter(
      (role: string) => roleFiltersState[role],
    );
    if (roleFilters && rolesArray.length > 0) {
      currentFilters = {
        ...currentFilters,
        roles: rolesArray.join(),
      };
    }
    return currentFilters;
  };

  const resetFiltersInModal = () => {
    dispatch(getList(() => {}));
    setIsEnabled(false);
    setFilters(FILTERS_INITIAL_STATE);
  };

  const handleCheckBox = (status: string) => {
    setFilters({
      ...filters,
      status: filters.status === status ? "" : status,
    });
  };

  return (
    <StyledModal
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={isEnabled}
    >
      <Box sx={{ ...managementModalStyle, height: "fit-content" }}>
        {loading ? (
          <CircularProgress color="inherit" size={20} />
        ) : (
          <Grid container mt={1} mb={1} sx={{ width: "100%" }}>
            <Grid item xs={11} sx={{ fontWeight: "400", fontSize: 16 }}>
              {"Filter"}
            </Grid>
            <Grid item xs={1}>
              <img
                aria-hidden="true"
                src={icons.modalClose}
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setIsEnabled(false);
                }}
              />
            </Grid>

            <Grid>
              {roleFilters && (
                <>
                  <Grid
                    item
                    sx={{
                      fontWeight: "900",
                      fontSize: 14,
                      paddingBottom: 1,
                      mt: 3,
                    }}
                  >
                    {"Role"}
                  </Grid>
                  <Grid sx={{ mb: 3 }}>
                    {Object.keys(ROLE_FILTERS_INITIAL_STATE).map((role) => (
                      <div
                        key={role}
                        aria-hidden="true"
                        onClick={() => handleRolesFilter(role)}
                      >
                        <Checkbox
                          checked={roleFiltersState[role]}
                          name={role}
                          label={capitializeAndRemoveUnderScore(role)}
                          onChange={() => {}}
                        />
                      </div>
                    ))}
                  </Grid>
                </>
              )}
              <Grid
                item
                sx={{ fontWeight: "900", fontSize: 14, paddingBottom: 1 }}
              >
                {"Invite Date"}
              </Grid>
              <DatePicker
                onChange={(date: Date) => {
                  setFilters({
                    ...filters,
                    hasDate: true,
                    date,
                  });
                }}
                hint="Invite Date"
                date={filters.hasDate ? filters.date : null}
              />

              <Grid
                item
                sx={{
                  fontWeight: "900",
                  fontSize: 14,
                  paddingBottom: 1,
                  mt: 3,
                }}
              >
                {"Status"}
              </Grid>
              <Grid sx={{ mb: 3 }}>
                <div
                  aria-hidden="true"
                  onClick={() => handleCheckBox("registered")}
                >
                  <Checkbox
                    checked={filters.status === "registered"}
                    name="registered"
                    label="Registered"
                    onChange={() => {}}
                  />
                </div>

                <div
                  aria-hidden="true"
                  onClick={() => handleCheckBox("invited")}
                >
                  <Checkbox
                    checked={filters.status === "invited"}
                    name="invited"
                    label="Invited"
                    onChange={() => {}}
                  />
                </div>
              </Grid>

              <Grid
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button onClick={resetFiltersInModal}>Reset</Button>
                <Button
                  onClick={handleConfirm}
                  type={ButtonType.normal}
                  colorScheme={ButtonColorScheme.gradient}
                >
                  Confirm
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Box>
    </StyledModal>
  );
};
